import { AssetDefinition } from '@cesdk/cesdk-js'

/*
id - unique id of template
label - i18n object of the label in ui
meta - object containing uri of scene and thumbUri of image thumbnail
*/

const templates: Array<AssetDefinition> = [
  {
    id: 'promition-sale-thisfriday',
    label: { en: 'Promotion Sale This Friday' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promition-sale-thisfriday/promition-sale-thisfriday.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promition-sale-thisfriday/promition-sale-thisfriday.png',
    },
  },
  {
    id: 'promotion-instore-sale-1',
    label: { en: 'Promotion In-Store Sale 1' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-instore-sale-1/promotion-instore-sale-1.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-instore-sale-1/promotion-instore-sale-1.png',
    },
  },
  {
    id: 'promotion-monday-sale',
    label: { en: 'Promotion Monday Sale' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-monday-sale/promotion-monday-sale.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-monday-sale/promotion-monday-sale.png',
    },
  },
  {
    id: 'promotion-sale-1',
    label: { en: 'Promotion Sale 1' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-sale-1/promotion-sale-1.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-sale-1/promotion-sale-1.png',
    },
  },
  {
    id: 'promotion-sale-2',
    label: { en: 'Promotion Sale 2' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-sale-2/promotion-sale-2.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-sale-2/promotion-sale-2.png',
    },
  },
  {
    id: 'promotion-sale-3',
    label: { en: 'Promotion Sale 3' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-sale-3/promotion-sale-3.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-sale-3/promotion-sale-3.png',
    },
  },
  {
    id: 'promotion-sale-friday',
    label: { en: 'Promotion Sale Friday' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/promotion-sale-friday/promotion-sale-friday.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/promotion-sale-friday/promotion-sale-friday.png',
    },
  },
  {
    id: `cyber_monday_20_off`,
    label: { en: 'Cyber Moday 20% off' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/6/cyber_monday_20_off.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/6/cyber_monday_20_off.png',
    },
  },
  {
    id: `happy_bday_10_off`,
    label: { en: 'Birthday 10% Off' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/9/happy_bday_10_off.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/9/happy_bday_10_off.png',
    },
  },
  {
    id: `happy_new_year_15_off_one_item`,
    label: { en: 'Happy New Year 15% Off' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/10/happy_new_year_15_off_one_item.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/10/happy_new_year_15_off_one_item.png',
    },
  },
  {
    id: `sale_25_off_one_item`,
    label: { en: '25% Off Single' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/11/sale_25_off_one_item.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/11/sale_25_off_one_item.png',
    },
  },
  {
    id: `saturday_blowout_25_off_150_10_off_50`,
    label: { en: 'Saturday Blowout' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/12/saturday_blowout_25_off_150_10_off_50.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/12/saturday_blowout_25_off_150_10_off_50.png',
    },
  },
  {
    id: `saturday_sale_10_off_selected_items`,
    label: { en: 'Saturday Sale 10%' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/13/saturday_sale_10_off_selected_items.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/13/saturday_sale_10_off_selected_items.png',
    },
  },
  {
    id: `saturday_savings_spree_20_off_entire_purchase`,
    label: { en: 'Saturday Savings Spree' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/14/saturday_savings_spree_20_off_entire_purchase.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/14/saturday_savings_spree_20_off_entire_purchase.png',
    },
  },
  {
    id: `sign_up_for_rewards`,
    label: { en: 'Sign Up For Rewards' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/15/sign_up_for_rewards.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/15/sign_up_for_rewards.png',
    },
  },
  {
    id: `we_miss_you_bogo`,
    label: { en: 'We Miss You BOGO' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/16/we_miss_you_bogo.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/16/we_miss_you_bogo.png',
    },
  },
  {
    id: `weekend_sale_10_off_50_5_off_30`,
    label: { en: 'Weekend 10% Off Sale' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/17/weekend_sale_10_off_50_5_off_30.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/17/weekend_sale_10_off_50_5_off_30.png',
    },
  },
  {
    id: `welcome_offer_10_off`,
    label: { en: 'Welcome Offer' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/18/welcome_offer_10_off.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/18/welcome_offer_10_off.png',
    },
  },
  {
    id: `welcome_offer_25_off_first_purchase`,
    label: { en: 'Welcome Offer 25% Off' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/19/welcome_offer_25_off_first_purchase.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/19/welcome_offer_25_off_first_purchase.png',
    },
  },
  {
    id: `blackfridaysaleearrings`,
    label: { en: 'Black Friday Earrings' },
    meta: {
      uri: 'https://imgly.oneshopretail.com/oneshop/20/blackfridaysaleearrings.scene',
      thumbUri:
        'https://imgly.oneshopretail.com/oneshop/20/blackfridaysaleearrings.png',
    },
  },
]

export { templates }
